import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
export default function getcompletedjobs(component){
  const Authorization='bearer '+localStorage.getItem('token');
  const rider_id=localStorage.getItem('rider_id');
  fetch(`${API_URL}getcompletedtrips`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
        body:JSON.stringify({rider_id})
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
          if(data[0]){
            if(data[0].status==='success'){
              component.props.completedJobsAction(data[0].data);
            }
            else {
              component.props.completedJobsAction('failure');
            }
          }
        })
}



// WEBPACK FOOTER //
// ./src/utility/api/getcompletedjobs.js